import { render, staticRenderFns } from "./GofixApprovalsContainer.vue?vue&type=template&id=4a041a78&"
import script from "./GofixApprovalsContainer.vue?vue&type=script&lang=js&"
export * from "./GofixApprovalsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports